import styled from '@emotion/styled';
import Image from 'next/image';
import apply from './apply.svg';
import pretest from './pretest.svg';
import result from './result.png';
import { breakpointMedium, breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';
import checkIcon from '@/public/images/ic-check.svg';

const Container = styled.div`
display: grid;
min-height: 380px;
padding-top: 20px;
grid-template-columns: auto 1fr;
row-gap: 8px;

@media (max-width: ${breakpointMedium}) {
  grid-template-columns: 1fr;
}
`;

const ImgContainer = styled.div`
width: 430px;
grid-column: 2 / 3;
grid-row: 1 / 10;
justify-self: end;

@media (max-width: ${breakpointMedium}) {
  grid-column: 1;
  grid-row: 1 / 2;
  justify-self: center;
}

@media (max-width: ${breakpointSmall}) {
  width: 320px;
}
`;

const StepTitle = styled.span`
color: ${colors.blue};
font-size: 22px;
font-weight: 700;

@media (max-width: ${breakpointSmall}) {
  font-size: 20px;
}
`;

const StepSub = styled.span`
padding: 4px 0;
font-size: 18px;
font-weight: 700;
word-break: keep-all;

@media (max-width: ${breakpointSmall}) {
  font-size: 16px;
}
`;

const TextWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 4px;
`;

const StepContent = styled.span<{ color?: string }>`
color: ${({ color }) => color};
font-size: 15px;

@media (max-width: ${breakpointSmall}) {
  font-size: 14px;
}
`;

const IconWrapper = styled.div`
display: flex;
align-items: flex-start;
gap: 6px;
`;

const CheckIcon = styled.div`
width: 24px;
height: 24px;
flex-shrink: 0;

@media (max-width: ${breakpointMedium}) {
  width: 20px;
  height: 20px;
}
`;

const AdditionaText = styled.span`
color: ${colors.black500};
font-size: 13px;
`;

const WarnText = styled.span`
padding-left: 30px;
color: ${colors.red};
font-size: 13px;
`;

export const PreTest = () => (
  <Container>
    <ImgContainer>
      <Image
        src={pretest}
        alt="pre test"
        style={{ maxWidth: '100%', height: 'auto' }}
      />
    </ImgContainer>
    <StepTitle>Step1. 사전 테스트</StepTitle>
    <StepSub>시험 응시 전 사전 테스트로 원활한 응시환경을 만들어보세요.</StepSub>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>응시일 기준 7일 전부터 하루 전까지 사전 테스트로 시험 환경 체험이 가능합니다.</StepContent>
    </IconWrapper>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>전반적인 내 PC 환경을 점검합니다. <StepContent color={colors.grey2}>(화면 응답, 키보드와 마우스 작동 상태, 웹캠과 인터넷 연결)</StepContent></StepContent>
    </IconWrapper>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>공정한 시험 환경을 위한 모바일 카메라 연결을 확인합니다.</StepContent>
    </IconWrapper>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>규정 신분증 업로드를 테스트 합니다.</StepContent>
    </IconWrapper>
  </Container>
);

export const Apply = () => (
  <Container>
    <ImgContainer>
      <Image
        src={apply}
        alt="apply"
        style={{ maxWidth: '100%', height: 'auto' }}
      />
    </ImgContainer>
    <StepTitle>Step2. 시험 응시</StepTitle>
    <StepSub>시험 1시간 전, 시험 응시페이지에서 온라인 시험장에 입장이 가능합니다.</StepSub>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <TextWrapper>
        <StepContent>PC, 웹캠, 스마트폰 연결 점검을 통해 시험 응시 환경을 준비합니다.</StepContent>
        <AdditionaText>(웹캠과 휴대폰 카메라 모두 연결되어야 시험 응시가 가능합니다.)</AdditionaText>
      </TextWrapper>
    </IconWrapper>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>모니토 앱을 통해 업로드한 신분증을 감독관이 확인합니다.</StepContent>
    </IconWrapper>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>공정한 시험 환경을 위한 응시자 주변환경을 점검하고 시험이 시작됩니다.</StepContent>
    </IconWrapper>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>응시언어는 접수 시점에 선택한 언어로 진행되며 변경하실 수 없습니다.</StepContent>
    </IconWrapper>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>외부 IDE 사용은 허용되지 않으나 서비스 페이지에 링크되어 있는 레퍼런스는 사용할 수 있습니다.</StepContent>
    </IconWrapper>
    <WarnText>※시험 시간 20분 전까지 입장해주세요! 이후에는 온라인 시험장에 입장할 수 없습니다.</WarnText>
    <WarnText>※PCSQL은 시험환경에서 레퍼런스 페이지가 제공되지 않습니다.</WarnText>
  </Container>
);

export const Complete = () => (
  <Container>
    <ImgContainer>
      <Image
        src={result}
        alt="result"
        style={{ maxWidth: '100%', height: 'auto' }}
      />
    </ImgContainer>
    <StepTitle>Step3. 시험 종료</StepTitle>
    <StepSub>시험 종료 후 자동채점하여 빠르게 결과를 확인할 수 있습니다.</StepSub>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>시험 문제를 다 풀고 제출하거나, 시험 시간이 종료되면 시험이 자동 종료됩니다.</StepContent>
    </IconWrapper>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>시험 종료 후 자동채점으로 빠르게 시험 점수와 합격 여부를 확인할 수 있습니다.</StepContent>
    </IconWrapper>
    <IconWrapper>
      <CheckIcon><Image src={checkIcon} alt="check" /></CheckIcon>
      <StepContent>시험 점수와 합격여부 확인은 최대 30분까지 시간이 소요될 수 있습니다.</StepContent>
    </IconWrapper>
  </Container>
);
